import { useQuery } from "@tanstack/react-query";
import { LuFileLock2 } from "react-icons/lu";
import { Link } from "react-router-dom";
import { handleFetchRequestsCount } from "../../api/requests";

export default function ManageRejected() {
  const { data: count } = useQuery({
    queryKey: ["rejectedCount"],
    queryFn:() => handleFetchRequestsCount({ status: 'rejected' }),
  });
  return (
    <Link
      to={`/requests/status/rejected`}
      className={`col-span-6 sm:col-span-4 lg:col-span-2 bg-red-100 p-4  border border-red-200`}

    >
      <div className="flex justify-between">
        <div className="flex flex-col justify-center items-center">
          <div className="flex items-center">
            <LuFileLock2 color="#323232" size={24} />
          <div className="mx-2">Rejected Requests</div>
          </div>
        </div>
        <div className="font-bold">{count}</div>
      </div>
    </Link>
  );
}
